import React from "react";
import Head from "next/head";
import { GetStaticProps } from "next";

import pageSeoData from "@/data/seo/page-data.json";
import SeoMetaData from "@/components/utils/seo-metadata";
import USPSMain from "@/components/fulfilment-partners/usps-main";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";

const USPSPartner = ({ seoData }: PageSeoHeaderProps) => {
  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <USPSMain />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: { seoData: pageSeoData.PARTNER_USPS },
  };
};

export default USPSPartner;
